import moment from 'moment'
import React, { useEffect, useState } from 'react'

const Ga4Push = ({ plan_entry, plan }) => {
  const [pushed, setPushed] = useState(false)
  useEffect(() => {
    if (pushed) return

    window.dataLayer ||= []
    if (plan_entry) {
      const plan = plan_entry?.plan
      const video = plan_entry?.video
      const instructor = plan?.coaches
        ?.map((c) =>
          [c?.coachInfo?.user?.firstName, c?.coachInfo?.user?.lastName].join(
            ' '
          )
        )
        .join(', ')
      window.dataLayer.push({
        page: 'planEntry',
        productId: plan.marketingId
      })
      window.dataLayer.push({
        event: 'class_page_view',
        class: plan_entry.title,
        series: plan.title,
        title: video?.title,
        instructor,
        style: plan_entry.style,
        difficulty: plan_entry.difficultyLevel || plan.difficultyLevel,
        intensity: String(plan_entry.intensityLevel || plan.intensityLevel),
        plan_slug: plan.slug,
        plan_release_date: moment(new Date(plan?.releaseDate)).format(
          'MM/DD/YYYY'
        ),
        availability: String(plan_entry.availabilityGating).toLowerCase()
      })
    } else {
      const instructor = plan?.coaches
        ?.map((c) => [c?.firstName, c?.lastName].join(' '))
        .join(', ')
      window.dataLayer.push({
        page: 'plan',
        productId: plan.marketingId
      })
      window.dataLayer.push({
        event: 'series_page_view',
        series: plan.title,
        style: plan.style,
        difficulty: plan.difficultyLevel,
        intensity: String(plan.intensityLevel),
        instructor,
        plan_slug: plan.slug,
        plan_release_date: moment(new Date(plan?.releaseDate)).format(
          'MM/DD/YYYY'
        ),
        availability: String(plan.availabilityGating).toLowerCase()
      })
    }

    setPushed(true)
  }, [plan_entry, plan, pushed])
  return <></>
}

export default Ga4Push
